export const MAIN_STATUS_LENGTH = {
  STATUS_INDEX: 8,
  STATUS_DIVIDER: 7,
};
